function r(t, ...a) {
  return a.reduce((e, n) => e.concat((n || "").split(" ")), []).map((e) => t[e]).filter((e) => e).join(" ");
}
export {
  r as default
};
